import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

interface UseDataCollectionConfigOptions {
  includeDraft?: boolean
}

export const useDataCollectionConfig = (options: UseDataCollectionConfigOptions = {}) => {
  const { includeDraft = true } = options
  const { dateFilters } = usePageDateFilters()

  const navigationFilters = {
    date: {
      defaultGranularity: 'range' as const,
      defaultValue: {
        from: dateFilters.startDate,
        to: dateFilters.endDate,
      },
      granularity: ['day', 'week', 'month', 'year', 'range'],
      type: 'date-navigator' as const,
    },
  }

  const presets = [
    ...(includeDraft
      ? [
          {
            label: i18n.t('expenses_v2.expense.status.draft'),
            filter: { status: ['draft'] },
          },
        ]
      : []),
    {
      label: i18n.t('expenses_v2.expense.status.pending'),
      filter: { status: ['pending'] },
    },
    {
      label: i18n.t('expenses_v2.expense.status.approved'),
      filter: { status: ['approved'] },
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      filter: { status: ['paid'] },
    },
  ]

  return { navigationFilters, presets }
}
